import { useSelector } from 'react-redux';

import { RootState } from '@lib/redux.lib/store';

export const useCurrentUserId = () => {
  const userId = useSelector(
    (state: RootState) => state?.app?.user?.profile?.id
  );
  const impersonatedUserId = useSelector(
    (state: RootState) => state?.app?.user?.impersonatedUser
  );

  const currentUserId = impersonatedUserId || userId;

  return currentUserId;
};
